import { documentSheetTokensCss } from '@/document-render/presentation/documentSheetLightTokens';

const SHEET_TOKENS_CSS = documentSheetTokensCss();

/**
 * Pins the design tokens the document sheet's chrome reads back to their light values on every `[data-document-sheet]`. The sheet is
 * white paper whatever the host theme is, so a dark theme must not hand its placeholders, "Add element", labels, selection outlines and
 * icons near-white values. React 19 hoists and de-duplicates a `<style>` that has an `href` and a `precedence`, so mounting this from
 * every page costs one rule in the document.
 */
export function DocumentSheetTokens() {
  return (
    <style href="rdb-document-sheet-tokens" precedence="rdb-document-sheet">
      {SHEET_TOKENS_CSS}
    </style>
  );
}
